export const MARK_STRIKETHROUGH = 'strikeThrough';
//# sourceMappingURL=models.js.map